export const GREY_300 = '#C5C8CD';
